import React from 'react';
import MediaQuery from 'react-responsive';

export const Sm = props => <MediaQuery {...props} minWidth={768} />;
export const Md = props => <MediaQuery {...props} minWidth={1024} />;
export const Lg = props => <MediaQuery {...props} minWidth={1280} />;
export const Xl = props => <MediaQuery {...props} minWidth={1600} />;

export const ToSm = props => <MediaQuery {...props} maxWidth={767} />;
export const ToMd = props => <MediaQuery {...props} maxWidth={1023} />;
export const ToLg = props => <MediaQuery {...props} maxWidth={1279} />;
export const ToXl = props => <MediaQuery {...props} maxWidth={1599} />;

export const SmOnly = props => (
  <MediaQuery {...props} minWidth={768} maxWidth={1279} />
);
export const LgOnly = props => (
  <MediaQuery {...props} minWidth={1280} maxWidth={1599} />
);



// WEBPACK FOOTER //
// ./src/components/modules/MediaQueries/index.js